import http from '../utils/http';
import Vue from 'vue';

export default {
    state: {
        users: []
    },
    mutations: {
        loadAll(state, payload) {
            state.users=payload;
        },
        addUser(state, payload) {
            const index = state.users.length
            Vue.set(state.users, index, payload) 
        },
        updateUser(state, payload) {
            const user = state.users.find(s => s.id == payload.id)
            const index = state.users.indexOf(user)
			Vue.set(state.users, index, {...user, ...payload})   
        },
        deleteUser(state, payload) {
            state.users =  state.users.filter(item => item.id !== payload)
        }
    },
    actions: {
        async fetchAllUsers({commit}) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.get(`/user`);  
                if (result) {
                   commit('loadAll', result.data)
                }               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //creating the user account by professor
        async addUser({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.post(`/auth/createUser`, payload);  
                if (result) {
                   commit('addUser', result.data)
                }               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            } 
        },
        async updateUser({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.put(`/user/${payload.id}`, payload);
                commit('updateUser', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        //user delete ADMIN only
        async deleteUser({commit}, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.delete(`/user/${payload}`);
                console.log(result)
                commit('deleteUser', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        }
    },
    getters: {
        users (state) {
            return state.users;
        }
    }
}